import {inject, Injectable} from '@angular/core';
import {API_MAP} from 'app/core/helpers/api.map';
import {Result} from 'app/core/models/result';
import {BaseDataService} from 'app/core/services/base-data.service';
import {Observable, tap, map} from 'rxjs';
import {
  GlobalSearchFilterProperties,
  GlobalSearchParams,
  SearchResultProperties, SearchResults
} from '../models/search-result.model';
import {DataService} from '../../../shared/services/data.service';
import {ElasticsearchService} from '../../../core/services/elasticsearch.service';

@Injectable({providedIn: 'root'})
export class SearchResultService extends BaseDataService<SearchResultProperties> {
  override controller = API_MAP.globalSearchPage;
  protected dataService = inject(DataService);
  private readonly elasticSearchService = inject(ElasticsearchService);

  override get(controller?: string): Observable<Result<SearchResultProperties>> {
    return super.get(controller ?? this.controller).pipe(
      tap((d: any) => {
        this.content.set(d.content);
        this.components.set(d.components);
      })
    );
  }

  getSearchFilters(pageTypesContainerPath: string): Observable<Result<GlobalSearchFilterProperties>> {
    return this.dataService.get<Result<GlobalSearchFilterProperties>>(API_MAP.globalSearchFilters(pageTypesContainerPath));
  }

  searchGlobal(params: GlobalSearchParams, fields: string[]): Observable<SearchResults> {
    return this.elasticSearchService.searchGlobalResults(params, fields).pipe(
      map(result => ({
        total: result.total,
        values: result.values ?? []
      } as SearchResults))
    );
  }
}
